import { StyleSheet } from "react-native";
import { COLORS } from "../../../config/colors";
import { THEME_COLORS } from "../../../theme/constants/themeColors";
import { verticalSize, height } from "../../../functions/responsive";
import { THEME_STYLES } from "../../../theme/constants/themeStyles";

export default StyleSheet.create({
  root: {
    flexDirection: "column",
    backgroundColor: THEME_COLORS.bgColor,
    justifyContent: "space-between",
    position: "relative",
    height: height(100),
  },
  successCont: {
    backgroundColor: COLORS.greenColor,
    borderRadius: 16,
    padding: 16,
    borderWidth: 1,
    borderBottomWidth: 3,
    borderColor: COLORS.primaryLight,
    marginVertical: 8,
    flexDirection: "row",
    alignItems: "center",
    ...THEME_STYLES.themeBorder,
  },
  thumbCont: {
    backgroundColor: THEME_COLORS.primaryDark,
    borderRadius: 100,
    padding: 12,
    justifyContent: "center",
    alignItems: "center"
  },
  rowStyle: {
    flexDirection: "row",
    // alignItems: 'center',
    justifyContent: "space-between"
  },
  whiteBox: {
    backgroundColor: THEME_COLORS.bgSecondary,
    borderWidth: 1,
    // borderBottomWidth: 3,
    // borderColor: COLORS.primaryLight,
    ...THEME_STYLES.themeBorder,
    ...THEME_STYLES.item,
    borderRadius: 16,
    padding: 16,
  },
  divider: {
    height: 1,
    backgroundColor: THEME_COLORS.neutralBorderColor,
    marginTop: 12,
    marginBottom: 6,
    borderRadius: 8
  }
});
